<template>
    <div class="py-4 text-3xl border-b-2 border-grey-light mb-4">
        <span class="font-bold">Laravel</span> <span class="font-light">Ward</span>
    </div>
</template>

<script>
    export default {
        name: 'TopNavigation'
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/TopNavigation.vue